<template>
    <div>
        <b-overlay :show="show" rounded="sm">
            <template #overlay>
                <div class="text-center">
                    <div class="h2 mb-0">
                        <b-icon-watch font-scale="3" animation="cylon" />
                    </div>
                    <h2 class="text-dark">Cargando ...</h2>
                </div>
            </template>
            <div id="my-player" />
        </b-overlay>
    </div>
</template>

<script>
import { BOverlay, BIconWatch } from "bootstrap-vue";

export default {
    components: {
        BOverlay,
        BIconWatch
    },
    props: {
        canal: {
            type: Object,
            default: () => {},
            require: true
        },
        infoPlayer: {
            type: Object,
            default: () => {},
            require: true
        }
    },
    setup() {},
    data() {
        return {
            show: true,
            playerConfig: {},
            container: null,
            player: null,
            chanel: [],
            channels: []
        };
    },
    created() {
        console.log("PlayerBitmovin");
        this.getChannels();
        this.loadScript();
    },
    methods: {
        loadScript() {
            const bitmovin = document.createElement("script");
            bitmovin.setAttribute(
                "src",
                "https://cdn.bitmovin.com/player/web/8/bitmovinplayer.js"
            );
            document.head.appendChild(bitmovin);
            setTimeout(() => {
                this.loadPlayer();
            }, 3000);
        },
        loadPlayer() {
            this.show = false;
            const key = atob(this.infoPlayer.key);

            this.playerConfig = {
                key: key,
                playback: {
                    muted: false,
                    autoplay: true,
                    timeShift: true
                },
                cast: {
                    enable: true
                },
                remotecontrol: {
                    type: "googlecast"
                },
                live: {
                    lowLatency: {
                        targetLatency: 3,
                        catchup: {
                            playbackRateThreshold: 0.075,
                            seekThreshold: 5,
                            playbackRate: 1.2
                        },
                        fallback: {
                            playbackRateThreshold: 0.075,
                            seekThreshold: 5,
                            playbackRate: 0.95
                        }
                    }
                },
                LicensingConfig: {
                    delay: 1000
                },
                skin: {
                    screenLogoImage: ""
                }
            };

            this.container = document.getElementById("my-player");
            this.player = new bitmovin.player.Player(
                this.container,
                this.playerConfig
            );
            this.switchChannel(this.canal.idcanal);
        },
        switchChannel(channelID, event) {
            if (!channelID) {
                return false;
            }

            if (event) {
                this.player.pause();
            }

            const title = this.chanel[channelID].nombre;
            const hls = this.chanel[channelID].link;

            const sourceConfig = {
                title: title,
                description: this.channels,
                hls: hls,
                poster: "images/poster.jpg"
            };

            this.player
                .load(sourceConfig)
                .then(function() {
                    console.log("Successfully loaded Source Config!");
                })
                .catch(function(reason) {
                    console.log("Error while loading source:", reason);
                });

            this.setPara();
        },
        setPara() {
            setTimeout(() => {
                document.querySelector(
                    "button.bmpui-ui-watermark"
                ).style.display = "none";

                const select = document.querySelector("#tt-select-player");

                select.addEventListener("change", event => {
                    this.switchChannel(event.target.value, true);
                });
            }, 4000);
        },
        getChannels() {
            this.$http
                .get("/api/canal", {
                    params: {
                        estado: "A"
                    }
                })
                .then(response => {
                    const obj = response.data.data;

                    this.channels = `<select class="select-css" id="tt-select-player">
                                    <option value="">Guia de Canales</option>`;

                    obj.forEach(item => {
                        if (item.op_live) {
                            this.channels += `<option value="${item.idcanal}" data-thumbnail="${item.path}">
                                            ${item.nombre}
                                            </option>`;
                        }
                        this.chanel[item.idcanal] = item;
                    });
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }
};
</script>

<style lang="css" scoped>
.scroll-area {
    position: relative;
    margin: auto;
    width: 400px;
    height: 300px;
}
.bmpui-ui-watermark {
    display: none;
}
</style>
